import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";

interface DuplicatePatientsParams {
  patientId?: string;
  firstName?: string;
  lastName?: string;
  dateOfBirth?: string;
}

export interface DuplicatePatient {
  patientId: string;
  mrn: string;
  firstName: string;
  lastName: string;
  lastVisit?: string | null;
}

export interface DuplicatePatientsResponse {
  patients: DuplicatePatient[];
}

// axios-case-converter auto-converts snake_case → camelCase
interface DuplicatePatientsRawApiResponse {
  patients?: {
    patientId: string;
    patientMrn: string;
    firstName?: string;
    lastName?: string;
    lastVisit?: string | null;
  }[];
}

export const useDuplicatePatients = ({
  patientId,
  firstName,
  lastName,
  dateOfBirth,
}: DuplicatePatientsParams) => {
  return useApi<DuplicatePatientsResponse>({
    queryOptions: {
      enabled: Boolean(patientId && firstName && lastName && dateOfBirth),
      queryKey: QueryKeys.Patient.Duplicates.DEFAULT(patientId as string),
      queryFn: async () => {
        const response =
          await axiosInstance.post<DuplicatePatientsRawApiResponse>(
            "/patient/duplicates",
            { patientId, firstName, lastName, dateOfBirth },
          );
        return {
          patients: (response.data.patients ?? []).map((p) => ({
            patientId: p.patientId,
            mrn: p.patientMrn,
            firstName: p.firstName ?? "",
            lastName: p.lastName ?? "",
            lastVisit: p.lastVisit,
          })),
        };
      },
    },
  });
};
